import React, { useEffect, useState, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { storeSearchSerials } from 'store/reducers/mainSlice';

import PermissionAllowed from 'ui-component/permissions/PermissionAllowed';

import { TbDatabaseExclamation } from 'react-icons/tb';
import StatusBadge from 'ui-component/StatusBadge';
import { FaPlus, FaSearch } from 'react-icons/fa';
import usePageTitle from 'hooks/usePageTitle';
import Filter from 'ui-component/filter-menu/Filter';
import { Skeleton, Avatar } from '@mui/material';
import NoRecordFoundIcon from 'assets/images/icons/no-records-found.svg';
import usePermissions from 'hooks/usePermissions';

import NoImage from 'assets/images/no-image.png';
import useIsMobile from 'utils/isMobileUtils';

import { ChevronLeftIcon } from 'ui-component/custom-icons/icons';

const Index = () => {
    const history = useNavigate();


    const getCookie = (name) => {
        const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
        if (match) return decodeURIComponent(match[2]);
        return null;
    };

	
    const setCookie = (name, value, days = 7) => {
        const expires = new Date(Date.now() + days*24*60*60*1000).toUTCString();
        document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires}; path=/`;
    };
	useEffect(() => {
        const cookieSettings = getCookie('location');	
        
		if (cookieSettings) {
		} else {
        	history(`/locations`);
		}
    }, []);
    
    const handleCookie = (location) => {
        setCookie('location', location);
        history(`/events`);
    }

    return (
        <>
            <div className="location-container">
                {/* Background Decorative Waves */}
                <div className="location-wave location-wave-1"></div>
                <div className="location-wave location-wave-2"></div>
                <div className="location-wave location-wave-3"></div>

                <div className="location-content">
                    <header className="location-header">
                        <h1>Select location</h1>
                    </header>

                    <div className="location-input-group">
                        <div className="location-select-wrapper">
                            <button className="location-button" onClick={() => handleCookie('FUJAIRAH')}>
                                Fujairah
                            </button>
                        </div>
                        <div className="location-select-wrapper">
                            <button className="location-button" onClick={() => handleCookie('AJMAN')}>
                                Ajman
                            </button>
                        </div>
                    </div>

                    {/* <button className="location-next-button" aria-label="Next">
                        <div
                            style={{
                                transition: 'transform 0.2s',
                                transform: 'rotate(180deg)',
                                marginLeft: '4px'
                            }}
                        >
                            <ChevronLeftIcon height={'25px'} width={'25px'} />
                        </div>
                    </button> */}
                </div>
            </div>
        </>
    );
};

export default Index;